import PadraoModel from 'src/core/model/PadraoModel.js'

export default class WebmotorsMarcaModel extends PadraoModel {
  recurso = 'webmotors/marcas';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Marcas Webmotors';

  colunasGrid = [
  ];

  form = {
    CodigoMarca: null,
    Descricao: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
